import React from 'react';
import cx from 'classnames';
import styles from './styles';
import { randomHash } from '../../../../utils/strings';

export default function Badge() {
  // SVG Masks have ID collisions in the DOM
  // Generate random hashes for them so we can have multiple instances
  const maskId = randomHash();
  const pathId = randomHash();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 41 43"
      width="41"
      height="43"
      className={cx(styles.badge, styles.svg)}
    >
      <defs />
      <defs>
        <path id={pathId} d="M0 0h41v43H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <mask id={maskId} fill="#fff">
            <use xlinkHref={`#${pathId}`} />
          </mask>
          <path
            fill="#B9C6E5"
            d="M0 43c2.111-4.81 9.506-8.561 16.57-8.58h6.143c.094 0 .183.015.278.016h1.437C33.58 34.436 41 26.95 41 17.716v-.997c0-9.234-7.42-16.72-16.572-16.72H16.57C7.505 0 .143 7.349.005 16.462H0v26.538z"
            mask={`url(#${maskId})`}
          />
        </g>
        <path
          fill="#172439"
          d="M20.44 25.98c-1.062 0-1.895-.89-1.895-1.963 0-1.1.833-1.964 1.894-1.964 1.035 0 1.895.864 1.895 1.964 0 1.073-.86 1.963-1.895 1.963M21.879 19.907h-2.904c0-3.85 4.444-4.843 4.444-7.697 0-1.518-1.086-2.278-2.701-2.278-1.591 0-2.778.864-3.283 2.409l-2.5-1.466C15.895 8.309 18.218 7 20.793 7c2.803 0 5.53 1.728 5.53 5.027 0 3.979-4.444 5.052-4.444 7.88"
        />
      </g>
    </svg>
  );
}
